<template>
  <div class="">
    <el-upload
      class="upload-demo"
      action="#"
      :http-request="imgUpload"
      :file-list="fileList"
      :show-file-list="false"
      :limit="limit"
    >
      <el-button size="mini" type="primary" style="width: 120px"
        >点击上传</el-button
      >
    </el-upload>
    <div class="file_list" v-if="fileList.length != 0">
      <el-table :data="fileList" border style="width: 100%">
        <el-table-column
          prop="name"
          label="文件名称"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column label="操作" align="center" width="80">
          <template slot-scope="scope">
            <el-button
              type="text"
              style="color: red"
              @click="handleRemove(scope.row, scope.$index)"
              v-preventReClick
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    limit: {
      type: Number,
      default: 1,
    },
    fileList: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {};
  },
  methods: {
    imgUpload(file) {
      var formData = new FormData();
      formData.append("file", file.file);
      this.$config.fileUpload(formData).then((res) => {
        /*
         * author：Gengbaodada
         * create by date：2023/09/26
         * content：上传文件提供参数 name(文件名) url(地址) uid(唯一标识)
         */
        if (res.data.code === 200) {
          this.fileList.push({
            name: file.file.name,
            url: res.data.data,
            uid: file.file.uid,
          });
          this.$emit("getUploadFile", this.fileList);
        }
      });
    },
    handleRemove(file, i) {
      this.fileList.splice(i, 1);
      this.$emit("getUploadFile", this.fileList);
    },
  },
};
</script>

<style lang="less" scoped>
.file_list {
  margin-top: 20px;
}
</style>
